import React from 'react';
import './FullscreenWordmarkLoader.less';
import { Wordmark } from 'app/components/logos';

export default function FullscreenWordmarkLoader() {
  return (
    <div className="fullscreen-wordmark-loader">
      <Wordmark className="fullscreen-wordmark-loader__logo-animation" />
    </div>
  );
}
